// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__UrXJY","listWrapper":"styles_listWrapper__nRETS"};